import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function AboutSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t,
    direction,
    locale
  } = useLanguage();
  return <section className="py-32 md:py-44 relative z-10 gradient-light" dir={direction} data-id="element-80">
      {/* Background decoration top-right */}
      <img src="https://cdn.magicpatterns.com/uploads/aVLvkvrFLX79R8UEYVhXQZ/about-circle.svg" alt="" className="absolute top-0 right-0 w-full h-auto pointer-events-none" data-id="element-81" />

      {/* Background decoration bottom-right */}
      <img src="https://cdn.magicpatterns.com/uploads/vstNuWX847AjniozqhZ2cD/3.svg" alt="" className="absolute bottom-0 right-0 w-[240px] h-auto pointer-events-none" style={{
      zIndex: 20,
      transform: 'translateY(56%)'
    }} data-id="element-82" />

      <div ref={ref} className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-83">
        <span className={`text-[#25B8D6] font-bold mb-4 block reveal-hidden ${isVisible ? 'animate-fade-up' : ''}`} style={{
        fontSize: '1.6rem'
      }} data-id="element-84">
          {t('about.theGroup')}
        </span>
        <h2 className={`text-2xl md:text-4xl font-medium text-[#061d76] !leading-[1.5] mb-10 reveal-hidden ${isVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-85">
          {t('about.description')}
        </h2>
        <div className={`text-start reveal-hidden ${isVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-86">
          <Link to={locale === 'ar' ? '/ar/about' : '/about'} className="btn-primary" data-id="element-87">
            {t('about.learnMore')}
          </Link>
        </div>
      </div>
    </section>;
}